<template>
	<div class="container-fluid">
		<toolbar>
			<h2>Project & Service Settings</h2>

			<projects-toolbar-controls
				:show-search="false"
				:show-quote="false"
				:show-new="false"
				:is-settings="true">
			</projects-toolbar-controls>
		</toolbar>

		<collapsible-panel :always-open="true" panel-size="sm">
			<template slot="panel">
				<panel-menu
					:menu-items="menuItems" 
					:active-item="activeSection"
					v-on:itemClick="panelItemClick">
				</panel-menu>
			</template>
			<template slot="main">
				<personnel-roles-widget v-if="hasModulePermWrite('Settings') && hasModulePermWrite('Projects') && hasModulePermWrite('Services') && (activeSection == 'All' || activeSection == 'Personnel Roles')">
				</personnel-roles-widget>

				<div class="row">
					<div :class="{'col-lg-6':activeSection == 'All','col-12':activeSection != 'All'}">
						<category-manager-widget 
							v-if="activeSection == 'All' || activeSection == 'Categories'"
							:categories="categories"
							v-on:modelChange="fetchData">
						</category-manager-widget>	

						<revenue-code-manager-widget 
							v-if="activeSection == 'All' || activeSection == 'Revenue Codes'"
							:revenue-codes="revenueCodes"
							v-on:modelChange="fetchData">
						</revenue-code-manager-widget>

						<project-default-settings v-if="activeSection == 'All' || activeSection == 'Job Defaults'"></project-default-settings>

						<job-numbering-settings v-if="activeSection == 'All' || activeSection == 'Project/Service Numbering'"></job-numbering-settings>

						<service-list-settings-widget v-if="activeSection == 'All' || activeSection == 'Service List Settings'"></service-list-settings-widget>
					</div>
					<div :class="{'col-lg-6':activeSection == 'All','col-12':activeSection != 'All'}">
						
						<file-tag-manager-widget
							v-if="activeSection == 'All' || activeSection == 'Job File Tags'" 
							:tags="jobFileTags"
							v-on:modelChange="fetchData">
						</file-tag-manager-widget>	

						<job-safety-tasks-manager-widget
							v-if="activeSection == 'All' || activeSection == 'Job Safety Tasks'">		
						</job-safety-tasks-manager-widget>
						
					</div>
				</div>
				
			</template>

		</collapsible-panel>

	</div>
</template>

<script>
import ProjectsToolbarControls from "@/pages/project/ProjectsToolbarControls"
import Toolbar from "@/layout_fragments/Toolbar"

import CategoryManagerWidget from "@/components/super_components/CategoryManagerWidget"
import FileTagManagerWidget from "@/components/super_components/FileTagManagerWidget"
import RevenueCodeManagerWidget from "@/components/super_components/RevenueCodeManagerWidget"
import JobSafetyTasksManagerWidget from "@/components/super_components/JobSafetyTasksManagerWidget"
import PersonnelRolesWidget from "@/components/super_components/PersonnelRolesWidget"
//import PurchaseOrderSettings from "@/components/super_components/PurchaseOrderSettings"
import ProjectDefaultSettings from "@/components/super_components/ProjectDefaultSettings"
import JobNumberingSettings from "@/components/super_components/JobNumberingSettings"
import ServiceListSettingsWidget from "@/components/super_components/ServiceListSettingsWidget"

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

export default {

	name: 'JobSettings',
	components: {
		Toolbar,
		CategoryManagerWidget,
		FileTagManagerWidget,
		RevenueCodeManagerWidget,
		JobSafetyTasksManagerWidget,
		PersonnelRolesWidget,
		CollapsiblePanel,
		PanelMenu,
		JobNumberingSettings,
		ProjectsToolbarControls,
		ProjectDefaultSettings,
		ServiceListSettingsWidget
	},
	data() {
		return {
			revenueCodes: [],
			categories: [],
			jobFileTags: [],
			menuItems: [
				"All",
				"Personnel Roles",
				"Categories",
				"Revenue Codes",
				//"Purchase Order Settings",
				"Job File Tags",
				"Job Safety Tasks",
				"Job Defaults",
				"Project/Service Numbering",
				"Service List Settings"
			],
			activeSection: "all"
		}
	},
	methods: {
		panelItemClick(item,index) {
			this.activeSection = item
			window.history.pushState({},"","/job-settings/"+item.slugify())
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			const params = {
				include: [
					{ model: 'Checklist', fields: ['id', 'name'] },
					{ model: 'FormChildTemplate', fields: ['id', 'description'] }
				]
			}

			let promises = [
				this.getJSON("Category/get", params),
				this.getJSON("RevenueCode/get"),
				this.getJSON("FileTag/get")
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.categories = responses[0].data
				vm.revenueCodes = responses[1].data
				vm.jobFileTags = responses[2].data
			})

		}
	},
	created() {
		this.fetchData()

		if (this.$route.params.setting) {
			let slug = this.$route.params.setting

			this.activeSection = this.menuItems.find(section => section.slugify() == slug)
		}
	}
}
</script>
